import { Link } from "react-router-dom";
import { Star, MapPin, Clock, ShieldCheck, IndianRupee } from "lucide-react";
import { formatINR } from "@/lib/api";

export default function DoctorCard({ doctor }) {
  return (
    <div data-testid={`doctor-card-${doctor.id}`} className="card group overflow-hidden">
      <div className="p-5">
        <div className="flex items-start gap-4">
          <div className="relative shrink-0">
            <img
              src={doctor.photo_url}
              alt={doctor.name}
              className="h-20 w-20 rounded-2xl border border-slate-200 object-cover"
              onError={(e) => { e.target.src = `https://ui-avatars.com/api/?background=1E40AF&color=fff&name=${encodeURIComponent(doctor.name)}&size=200`; }}
            />
            <span className="absolute -bottom-1.5 -right-1.5 flex h-6 w-6 items-center justify-center rounded-full bg-emerald-500 text-white ring-2 ring-white">
              <ShieldCheck className="h-3.5 w-3.5" />
            </span>
          </div>
          <div className="min-w-0 flex-1">
            <div className="flex items-start justify-between gap-2">
              <div className="min-w-0">
                <h3 className="truncate text-base font-bold text-slate-900">{doctor.name}</h3>
                <div className="truncate text-xs font-medium text-blue-700">{doctor.specialty}</div>
              </div>
              <div className="flex shrink-0 items-center gap-1 rounded-lg bg-amber-50 px-2 py-1 text-xs font-bold text-amber-700">
                <Star className="h-3.5 w-3.5 fill-amber-500 text-amber-500" />
                {doctor.rating?.toFixed(1) || "—"}
              </div>
            </div>
            <div className="mt-1 truncate text-xs text-slate-500">{doctor.qualification}</div>
            <div className="mt-2 flex items-center gap-1.5 text-xs text-slate-600">
              <Clock className="h-3.5 w-3.5" />
              <span>{doctor.experience_years} yrs exp</span>
              <span className="text-slate-300">•</span>
              <span>{doctor.reviews_count || 0} reviews</span>
            </div>
          </div>
        </div>

        <div className="mt-4 flex items-start gap-2 rounded-xl bg-slate-50 p-3 text-xs text-slate-600">
          <MapPin className="mt-0.5 h-3.5 w-3.5 shrink-0 text-slate-400" />
          <div className="min-w-0">
            <div className="truncate font-medium text-slate-800">{doctor.clinic_name}</div>
            <div className="truncate">{doctor.city}</div>
          </div>
        </div>

        <div className="mt-4 flex items-center justify-between">
          <div className="flex items-center gap-1 text-slate-900">
            <IndianRupee className="h-4 w-4 text-emerald-600" />
            <span className="text-lg font-extrabold">{formatINR(doctor.consultation_fee).replace("₹","")}</span>
            <span className="text-xs font-medium text-slate-500">consultation</span>
          </div>
          <span className="badge bg-emerald-50 text-emerald-800">Available Today</span>
        </div>

        <div className="mt-4 flex gap-2">
          <Link
            to={`/doctor/${doctor.id}`}
            data-testid={`view-profile-btn-${doctor.id}`}
            className="btn-outline flex-1 !py-2 !text-sm"
          >
            View Profile
          </Link>
          <Link
            to={`/book/${doctor.id}`}
            data-testid={`book-btn-${doctor.id}`}
            className="btn-primary flex-1 !py-2 !text-sm"
          >
            Book Appointment
          </Link>
        </div>
      </div>
    </div>
  );
}
